import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ElementRef,
  ViewChild
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { AbstractControl, FormControl, ReactiveFormsModule, Validators } from "@angular/forms";
import { MAT_DATE_LOCALE, MatNativeDateModule, DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";
import {
  MatCalendarCellCssClasses,
  MatDatepicker,
  MatDatepickerModule,
} from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import * as moment from "moment";
import { PipesModule } from "src/app/shared/pipes/pipe-module";
import { DateFormatModule } from "../../../filters/date-format/data-format.module";
import { modeType } from "src/app/shared/interfaces/inputype.interface";
// ------------------------------------------------------------------------------
import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import { IconComponent } from "../../../icon/icon.component";


@Component({
  selector: "mg-input-date",
  templateUrl: "./date.component.html",
  styleUrls: ["./date.component.scss"],
  // encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    PipesModule,
    DateFormatModule,
    IconComponent,
  ], 
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'es-ES'},
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
  ],


})
export class DateComponent implements OnInit, OnChanges {
  @Input() inputControl: FormControl | AbstractControl<any, any> = new FormControl(null);
  @Input() label: string = "";
  @Input() required: boolean = false;
  @Input() placeholder: string = "";
  @Input() mode: modeType;
  @Input() min: Date;
  @Input() max: Date | null = null;
  @Input() isLoading: boolean = false;
  @Input() withLabel: boolean = true;
  @Input() hint: boolean = false;
  @Input() initDayFilter: Date;
  @Input() hintPosition?: 'down' | 'right' = 'down';
  @Input() hintmessage: string = "";
  //Fechas
  @Input() serie1: string[] = [];
  @Input() serie2: string[] = [];
  @Input() serie3: string[] = [];
  @Input() serie4: string[] = [];
  @Input() serie5: string[] = [];
  @Input() cssserie1: string = "";
  @Input() cssserie2: string = "";
  @Input() cssserie3: string = "";
  @Input() cssserie4: string = "";
  @Input() cssserie5: string = "";
  @Input() titleserie1: string = "";
  @Input() titleserie2: string = "";
  @Input() titleserie3: string = "";
  @Input() titleserie4: string = "";
  @Input() titleserie5: string = "";
  @Input() aDisabledDaysByDayOfWeek: number[] = [];
  @Input() aDisabledDays: string[] = [];
  @Input() aEnableDays: string[] = [];
  @Input() arrayHoursPermiso?: any = [];
  @Input() isDisableErrors: boolean = false

  @ViewChild("datepickerFooter", { static: false })
  datepickerFooter: ElementRef;
  @ViewChild("datepicker", { static: false }) datepicker: MatDatepicker<any>;

  dateClass = (cellDate: any, view: any): MatCalendarCellCssClasses => {
    if (view !== "month") return "";

    const current = moment(cellDate).startOf("day");

    const serie1 = (this.serie1 ?? []).map(d => moment(d).startOf("day"));
    const serie2 = (this.serie2 ?? []).map(d => moment(d).startOf("day"));
    const serie3 = (this.serie3 ?? []).map(d => moment(d).startOf("day"));
    const serie4 = (this.serie4 ?? []).map(d => moment(d).startOf("day"));
    const serie5 = (this.serie5 ?? []).map(d => moment(d).startOf("day"));

    try {
      if (serie1.some(d => d.isSame(current))) return this.cssserie1;
      if (serie2.some(d => d.isSame(current))) return this.cssserie2;
      if (serie3.some(d => d.isSame(current))) return this.cssserie3;
      if (serie4.some(d => d.isSame(current))) return this.cssserie4;
      if (serie5.some(d => d.isSame(current))) return this.cssserie5;
      return "";
    } catch {
      return "";
    }
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["mode"]) this.initMode();
    
    if (changes["serie1"] || changes["serie2"] || changes["serie3"] || changes["serie4"] || changes["serie5"]) {
      this.updateCalendar();
    }
  }

  ngOnInit(): void {
    this.setValidators();
    // this.dateAdapter.setLocale("es-ES");
    this.initMode();
  }

  initMode(){
    switch(this.mode){
      case 'read':
        this.inputControl!.disable();
        break;

      case 'create':
      case 'update':
        this.inputControl!.enable();
        break;
    }
  }

  updateCalendar() {
    if (this.datepicker && this.datepicker.opened) {
      const currentValue = this.inputControl.value;
      this.inputControl.setValue(null);
      setTimeout(() => {
        this.inputControl.setValue(currentValue);
      }, 0);
    }
  }

  setValidators() {
    if (this.required) {
      this.inputControl!.setValidators([Validators.required]);
    }
  }

  // formatDate(event: any) {
  //   let date = this.datepipe.transform(event.value, "yyyy-MM-dd", "es-ES");
  //   this.inputControl!.setValue(date);
  // }

  onOpen() {
    let titles: string[] = [
      this.titleserie1,
      this.titleserie2,
      this.titleserie3,
      this.titleserie4,
      this.titleserie5,
    ];
    if (!titles.every((x) => x === "")) {
      this.appendFooter();
    }
  }

  private appendFooter() {
    const matCalendar = document.getElementsByClassName(
      "mat-datepicker-content"
    )[0] as HTMLElement;
    matCalendar.appendChild(this.datepickerFooter.nativeElement);
  }

  filters = (d: Date | null): boolean => {
    if (d != null) {
      let newDate: moment.Moment = moment(d);
      return this.searchDisabled(newDate);
    }
    return true;
  };

  searchDisabled(newDate: moment.Moment) {
    if (this.aEnableDays?.length) {
      return this.aEnableDays.includes(newDate.format("YYYY-MM-DD"));
    } else {
      if (this.aDisabledDays?.length &&
          this.aDisabledDays.includes(newDate.format("YYYY-MM-DD"))) {
        return false;
      }

      if (this.aDisabledDaysByDayOfWeek?.length &&
          this.aDisabledDaysByDayOfWeek.includes(newDate.day())) {
        return false;
      }

      return true;
    }
  }

  public showErrors() {
    const divs = document.getElementById("david_prueba") as HTMLElement;
    const firstChild = divs!.children[1] as HTMLElement;
    firstChild.style.display = "block";
  }

  public hideErrors() {
    const divs = document.getElementById("david_prueba") as HTMLElement;
    const firstChild = divs!.children[1] as HTMLElement;
    firstChild.style.display = "none";
  }
}